import Swal from 'sweetalert2';

//Constantes auxiliares para sweetalerts:
const scratchConfirmationAlertContent = {
    title: '<p>@provider: @name</p>',
    // showClass: { popup: 'animated fadeInDown faster' },
    icon: 'info',
    html: '<p style="font-size: 0.75em; text-align: center">¿Estás seguro de ejecutar esta operación? Aunque el proceso tardará un poco, puedes seguir navegando en la consola.</p>',
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText:
        'Continuar<i class="fa fa-thumbs-up" style="margin-left: 5px"></i>',
    cancelButtonText:
        'Cancelar<i class="fa fa-thumbs-down" style="margin-left: 5px"></i>',
}

const retryConfirmationAlertContent = {
    title: '<p>@provider: @name</p>',
    // showClass: { popup: 'animated fadeInDown faster' },
    icon: 'info',
    html: '<p style="font-size: 0.75em; text-align: center">¿Estás seguro de <b>reintentar esta descarga</b>?</p>',
    showCancelButton: true,
    focusConfirm: false,
    focusCancel: true,
    confirmButtonText:
        'Continuar<i class="fa fa-thumbs-up" style="margin-left: 5px"></i>',
    cancelButtonText:
        'Cancelar<i class="fa fa-thumbs-down" style="margin-left: 5px"></i>',
}

const cancelConfirmationAlertContent = {
    title: '<p>@provider: @name</p>',
    // showClass: { popup: 'animated fadeInDown faster' },
    icon: 'info',
    html: '<p style="font-size: 0.75em; text-align: center">¿Estás seguro de <b>cancelar esta descarga</b>? No es posible reversar la cancelación, aunque siempre puedes instanciar nuevos procesos.</p>',
    showCancelButton: true,
    focusConfirm: false,
    focusCancel: true,
    confirmButtonText:
        'Continuar<i class="fa fa-thumbs-up" style="margin-left: 5px"></i>',
    cancelButtonText:
        'Cancelar<i class="fa fa-thumbs-down" style="margin-left: 5px"></i>',
}

export const replaceSwalContentWithSouceInfo = (swalContent, downloadSource) => {
    if (downloadSource.description.split(":")[1] !== undefined) {
        swalContent.title = swalContent.title.replace("@name", downloadSource.description.split(":")[1]);
        swalContent.title = swalContent.title.replace("@provider", downloadSource.description.split(":")[0]);
    }
    else {
        swalContent.title = swalContent.title.replace("@name", "");
        swalContent.title = swalContent.title.replace("@provider:", downloadSource.description.split(":")[0]);
    }
    return swalContent;
}

export const addVariableContentForScratchRequest = (swalContent, downloadSource) => {
    if(downloadSource.parametrization.variables){
        swalContent.html += '<p style="font-size: 0.75em; text-align: center">Esta operación cuenta con variables de entrada, por favor ingrese los datos antes de ejecutar la operación</p>'
        for(var i = 0; i < downloadSource.parametrization.variables.length; i++){
            swalContent.html += '<p style="font-size: 0.75em;">' + downloadSource.parametrization.variables[i].name + ':</p>';
            if(downloadSource.parametrization.variables[i].options){
                swalContent.html += '<select style="font-size: 0.75em" id="swal-input' + i + '" class="swal2-input col-8">';
                for(var j = 0; j < downloadSource.parametrization.variables[i].options.length; j++){
                    swalContent.html += '<option value="' + downloadSource.parametrization.variables[i].options[j] + '" class="swal2-input col-8"' + (j == downloadSource.parametrization.variables[i].default ? 'selected' : '') + '>' + downloadSource.parametrization.variables[i].options[j] + '</option>';
                }
                swalContent.html += '</select>';
            }else{
                swalContent.html += '<input placeholder="' + downloadSource.parametrization.variables[i].name + '" style="font-size: 0.75em" id="swal-input' + i + '" value="' + downloadSource.parametrization.variables[i].default + '" class="swal2-input col-8">';
            }
        }
        swalContent.preConfirm = () => {
            var dict = {}
            for(var i = 0; i < downloadSource.parametrization.variables.length; i++){
                dict[downloadSource.parametrization.variables[i].name] = document.getElementById('swal-input' + i).value
            }
            return dict;
        }
    }
    return swalContent;
}

export const getSwalContentForScratchRequest = (downloadSource) => {
    let swalContent = { ...scratchConfirmationAlertContent };
    swalContent = addVariableContentForScratchRequest(swalContent, downloadSource);
    swalContent = replaceSwalContentWithSouceInfo(swalContent, downloadSource);

    return swalContent;
}

export const getSwalContentForRetryRequest = (downloadSource) => {
    let swalContent = { ...retryConfirmationAlertContent };
    swalContent = replaceSwalContentWithSouceInfo(swalContent, downloadSource);

    return swalContent;
}

export const getSwalContentForCancelRequest = (downloadSource) => {
    let swalContent = { ...cancelConfirmationAlertContent };
    swalContent = replaceSwalContentWithSouceInfo(swalContent, downloadSource);

    return swalContent;
}

export const retryDownloadProcess = (props, targetProcess, downloadSource, registerAuditProcess, callbackFunction) => {
    let executeScratchEndpoint = process.env.REACT_APP_API_URL + "/processes/" + targetProcess.id + "/retry_pipeline_scratch/";
    fetch(executeScratchEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': 'Token ' + props.activeUser.authToken },
        body: JSON.stringify({})
    }).then(serverResponse =>{
        switch (serverResponse.status) {
            case 200:
            case 201:
                serverResponse.json().then(serverResponse => {
                    Swal.fire('', 'El proceso de descarga <b>ha sido reintentado</b> con éxito', 'success');
                    registerAuditProcess(props, {
                        "event_type": "SCRATCH_RETRYED",
                        "description": "El usuario reintentó la descarga <b>" + downloadSource.description.replace(":", ": ") + "</b>"
                    });
                    setTimeout(() => { callbackFunction(); }, 500);
                });
                break;
            default:
                Swal.fire('', 'El proceso de reintento no pudo ejecutarse adecuadamente', 'error');
                break;
        }
    })
}

export const getFileFromS3 = (props, targetProcess, registerAuditProcess, callbackFunction) => {

    let executeScratchEndpoint = process.env.REACT_APP_API_URL + "/processes/" + targetProcess.id + "/get_file_from_bucket";
    fetch(executeScratchEndpoint, {
        method: 'GET',
        headers: { 'Authorization': 'Token ' + props.activeUser.authToken },
        //body: JSON.stringify({})
    }).then(serverResponse =>{
        switch (serverResponse.status) {
            case 200:
                case 201:
                serverResponse.json().then(serverResponse => {
                    registerAuditProcess(props, {
                        "event_type": "PRESIGNED_FILE_DOWNLOADED",
                        "description": "El usuario descargo <b>" + targetProcess.linkedDownloadSource.description.replace(":", ": ") + "</b>"
                    });
                    setTimeout(() => { callbackFunction(serverResponse.presigned_url); }, 500);
                });
                break;
            default:
                Swal.fire('', 'El proceso de reintento no pudo ejecutarse adecuadamente', 'error');
                break;
        }
    })
}

export const cancelDownloadProcess = (props, targetProcess, downloadSource, registerAuditProcess, callbackFunction) => {
    let executeScratchEndpoint = process.env.REACT_APP_API_URL + "/processes/" + targetProcess.id + "/cancel_process/";

    fetch(executeScratchEndpoint, {
        method: "DELETE",
        headers: { "Content-Type": "application/json", 'Authorization': 'Token ' + props.activeUser.authToken },
        body: JSON.stringify({})
    })
        .then(serverResponse => {
            //console.log(`serverResponse.status ${serverResponse.status}`);
            switch (serverResponse.status) {
                case 200:
                case 201:
                    serverResponse.json().then(serverResponse => {
                        Swal.fire('', 'El proceso de descarga <b>ha sido cancelado</b> con éxito', 'success');

                        registerAuditProcess(props, {
                            "event_type": "SCRATCH_CANCELLED",
                            "description": "El usuario canceló la descarga <b>" + downloadSource.description.replace(":", ": ") + "</b>"
                        });

                        setTimeout(() => { callbackFunction(); }, 500);
                    });
                    break;

                default:
                    Swal.fire('', 'El proceso de cancelación no pudo ejecutarse adecuadamente', 'error');
                    break;
            }
        })
        .catch(err => {
            console.log(err);
            Swal.fire('', 'El proceso de cancelación no pudo ejecutarse adecuadamente', 'error');
        });
}